import { useDispatch, useSelector } from "react-redux";
import { isViewerReady } from "../../api/features/viewer/selectors";
import useUser from "../user/useUser";
import { useEffect } from "react";
import {
  combineDetailedStatuses,
  DetailedLoadStatus,
} from "../../../../../common/utils/async-status";
import { applyTTSSettings } from "../../api/features/tts/actions";
import useBookInfo from "../bookinfo/useBookInfo";

export default function useApplyTTSSettings() {
  const viewerReady = useSelector(isViewerReady);
  const { loadStatus: userLoadStatus } = useUser();
  const { loadStatus: bookInfoLoadStatus } = useBookInfo();
  const dispatch = useDispatch();

  const loadStatus = combineDetailedStatuses([
    userLoadStatus,
    bookInfoLoadStatus,
  ]);

  useEffect(() => {
    if (viewerReady && loadStatus === DetailedLoadStatus.OK) {
      dispatch(applyTTSSettings());
    }
  }, [viewerReady, loadStatus, dispatch]);
}
